import React from "react";
import { Box } from '@mui/joy';
import { Bar } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import Pivot from "./AccettateAreaShop.Pivot";
import AccettateAnalisiKPISet from "../accettateAnalisi/AccettateAnalisi.KPISet";

const AccettateAreaShop = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showPivot = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Accepted')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <AccettateAnalisiKPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showPivot &&
                <Box className="report-itemgroup">
                    <Pivot dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

        </Box>
    )
}

export default AccettateAreaShop;
